<script setup>
import { onMounted, computed } from "vue";
import { useLoteStore } from "@/store/loteStore";

const props = defineProps({
  LotesSubastaStore: Object,
  usuarioStore: Object,
});

const auction = computed(() => props.LotesSubastaStore?.auction || {});
const terminoCondicion = computed(() => auction.value?.termino_condicion || null);
const archivo = computed(() => terminoCondicion.value?.archivo || null);
const vistaPrevia = computed(() => archivo.value?.vista_previa || null);

const loteStore = useLoteStore();
const aceptoTerminos = computed(() => loteStore.aceptoTerminos);
const isLogged = props.usuarioStore.isLogged;

onMounted(async () => {
  if (auction.value?.id) {
    await loteStore.obtenerAceptoTerminos(auction.value.id);
  }
});

async function aceptarTerminosCheck() {
  if (!auction.value?.id) return;
  await loteStore.aceptarTerminosCondiciones(auction.value.id);
  await loteStore.obtenerAceptoTerminos(auction.value.id);
}
</script>

<template>
  <div class="card shadow-sm p-4">
    <div
      class="col-md-12 p-2 mt-3"
      v-if="archivo && vistaPrevia"
    >
      <iframe :src="vistaPrevia" width="100%" height="500px"></iframe>

      <div class="form-check mt-3" v-if="!aceptoTerminos && isLogged">
        <input
          class="form-check-input"
          type="checkbox"
          v-model="aceptoTerminos"
          @blur="aceptarTerminosCheck"
        />
        <label class="form-check-label">
          Aceptar Términos y Condiciones
        </label>
      </div>
    </div>
  </div>
</template>